import { Button } from "@mui/material";

export const SearchSettingsButton = ({ children, sx = [], ...props }) => {
	return (
		<Button
			size="small"
			color="inherit"
			sx={[
				{
					fontSize: "12px",
					fontWeight: "400",
					lineHeight: "normal",
					padding: "2px 6px",
					borderColor: "rgba(0, 0, 0, 0.23)",
					textTransform: "none",
					"& .MuiButton-startIcon": {
						marginRight: "2px",
					},
					"& .MuiSvgIcon-root": {
						fontSize: "12px",
					},
				},
				...(Array.isArray(sx) ? sx : [sx]),
			]}
			{...props}
		>
			{children}
		</Button>
	);
};
